//@helpers
const actionTypes = require('constants/actionTypes');

//@actions
const signaturePatternActions = require('actions/signaturePattern');

// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
const { updateConsents } = require('actions/gdprConsents');
const apiURLBuilder = require('core/apiURLBuilder');

const getConsentsInProgress = () => ({
    type: actionTypes.CONSENTS_PROFILE_REQUEST,
});

const getConsentsSuccess = (response) => ({
    type: actionTypes.CONSENTS_PROFILE_SUCCESS,
    payload: { response }
});

const getConsentsFailure = () => ({
    type: actionTypes.CONSENTS_PROFILE_FAILURE,
});

const updateConsentsFailure = () => ({
    type: actionTypes.UPDATE_CONSENTS_GDPR_ERROR,
})

const updateConsentsSuccess = (response, valueCommercial) => ({
    type: actionTypes.UPDATE_CONSENTS_GDPR_SUCCESS,
    valueCommercial: valueCommercial
})

const nextStep = () => ({
    type: actionTypes.UPDATE_CONSENTS_NEXT_STEP,
})

const lastStep = () => ({
    type: actionTypes.UPDATE_CONSENTS_LAST_STEP,
})

const resetConsentsProfile = () => ({
    type: actionTypes.UPDATE_RESET_CONSENTS_GDPR,
})

const getConsents = () => (dispatch) => {
    const requestData = {
        query: {
            "placementId": 'profile',
            "status": ["ACCEPTED", "PENDING", "NOT_ACCEPTED"]
        }
    };

    dispatch(getConsentsInProgress());
    APIGet(dispatch, apiURLBuilder.getURL('consents'), requestData)
        .then(response => dispatch(getConsentsSuccess(response)))
        .catch(error => dispatch(getConsentsFailure(error)));
}


const updateConsentsProfile = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(updateConsents(dataToken, true))
        .then(response => dispatch(updateConsentsSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(updateConsentsFailure());
            } else {
                throw response;
            }
        });
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });

}

module.exports = {
    getConsents,
    updateConsentsProfile,
    nextStep,
    lastStep,
    resetConsentsProfile
}
